// Third-party
import React from 'react';

// Components
import DatesDisclaimer from './DatesDisclaimer';

// Utils
import { getAllocationsAsAtDates } from '../../../../utils/disclaimers/comparison';
import { formatMessageWithLocale } from '../../../../utils/i18n';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

interface Props {
  items: ComparisonItem[];
  showItemNames?: boolean;
  locale?: Locale;
}

const ESGImpliedTemperatureRiseDisclaimer = ({ items, showItemNames, locale }: Props) => (
  <DatesDisclaimer
    globalPrefix={formatMessageWithLocale('Disclaimers.ESGAnalysis.ImpliedTemperatureRise', locale)}
    itemPrefix={formatMessageWithLocale('Disclaimers.EndingOn', locale)}
    itemDates={getAllocationsAsAtDates(items, locale)}
    showItemNames={showItemNames}
    locale={locale}
  />
);

export default ESGImpliedTemperatureRiseDisclaimer;
